var map = {
	"./adult/nn/skrivehastighet-data.json": 666,
	"./adult/no/skrivehastighet-data.json": 667,
	"./child/se/skrivehastighet-data.json": 668,
	"./youth/de/skrivehastighet-data.json": 669,
	"./youth/nn/skrivehastighet-data.json": 670,
	"./youth/no/skrivehastighet-data.json": 671,
	"./youth/se/skrivehastighet-data.json": 672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 141;